import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Blockquote",
  "use": "Blockquote-usage",
  "viewBox": "-9.5 -14 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-9.5 -14 64 64\" id=\"Blockquote\"><title>QUOTE</title><path d=\"M0 16.5L14.7 0l3.9 2.1L13.65 15l4.95 1.5V36H0V16.5zm26 0L40.7 0l3.9 2.1L39.65 15l4.95 1.5V36H26V16.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol